import styled from 'styled-components';

const HudPanel = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    justify-self: center;
    padding: 4px;
    grid-column: hud-start / hud-end;
    grid-row: top / timeline-top;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }

    @media (max-width: 1452px) {
        display: none;
    }
`;

export default HudPanel;
